import { Button, IconButton, InputAdornment, Menu, MenuItem, TextField, Tooltip, Badge } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';

// import DateField from '../../../components/UI/DateField';

const initFilter = {
  status: '',
  scenario: '',
  questionType: '',
};

const FilterMenu = ({ onFilterReset, filterState, onFilterApply }) => {
  const [filterStateLocal, setFilterStateLocal] = useState({ ...initFilter });

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setFilterStateLocal(filterState);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setFilterStateLocal({ ...initFilter });
  };

  const handleFilterApply = () => {
    onFilterApply(filterStateLocal);
    handleClose();
  };

  const isThisResetState =
    filterState?.status !== '' || filterState?.scenario !== '' || filterState?.questionType !== '';

  const handleFilterReset = () => {
    isThisResetState && onFilterReset();
    setFilterStateLocal(initFilter);
    handleClose();
  };

  return (
    <div>
      <Tooltip title="Filter">
        <IconButton
          size="small"
          onClick={handleClick}
          sx={{
            display: 'flex',
            alignItems: 'center',
            // ml: 2,
            height: '40px',
            width: '40px',
            backgroundColor: '#027c34',
            '&:hover': { backgroundColor: '#027d35' },
          }}
        >
          <Badge color="error" variant="dot" invisible={!isThisResetState}>
            <FilterAltIcon sx={{ color: 'white' }} />
          </Badge>
        </IconButton>
      </Tooltip>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            width: '350px',
            padding: '0px 8px',
          },
        }}
      >
        <h2>Filter</h2>
        <TextField
          value={filterStateLocal?.scenario}
          onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, scenario: e.target.value }))}
          sx={{
            my: '8px',
          }}
          select
          label="Scenario"
          size="small"
          fullWidth
          variant="outlined"
        >
          <MenuItem value="DowngradePlan">Downgrade Plan</MenuItem>
          <MenuItem value="DeleteAccount">Delete Account</MenuItem>
          <MenuItem value="UpgradePlan">Upgrade Plan</MenuItem>
          <MenuItem value="MonthlyFeedback">Monthly Feedback</MenuItem>
        </TextField>
        <TextField
          value={filterStateLocal?.questionType}
          onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, questionType: e.target.value }))}
          sx={{
            my: '8px',
          }}
          select
          label="Question Type"
          size="small"
          fullWidth
          variant="outlined"
        >
          <MenuItem value="text">Text Field</MenuItem>
          <MenuItem value="options">Options</MenuItem>
          <MenuItem value="yesNo">Yes or No</MenuItem>
        </TextField>
        <TextField
          value={filterStateLocal?.status === true ? 'Active' : filterStateLocal?.status === false ? 'Inactive' : ''}
          onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, status: e.target.value === 'Active' }))}
          sx={{
            my: '8px',
          }}
          select
          label="Status"
          size="small"
          fullWidth
          variant="outlined"
        >
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Inactive">Inactive</MenuItem>
        </TextField>

        {/* Mutual Room */}
        {/* <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', margin: '2px 0px' }}>
          <span className="filter-sub-label-x2" style={{ paddingLeft: '6px' }}>
            Mutual Rooms
          </span>
          <div style={{ display: 'flex', gap: '8px' }}>
            <TextField
              style={{ marginBottom: '8px' }}
              value={filterStateLocal?.mutualRoomMin}
              onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, mutualRoomMin: e.target.value }))}
              label="Min"
              size="small"
              type="number"
              fullWidth
              variant="outlined"
            />
            <TextField
              style={{ marginBottom: '8px' }}
              value={filterStateLocal?.mutualRoomMax}
              onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, mutualRoomMax: e.target.value }))}
              label="Max"
              size="small"
              type="number"
              fullWidth
              variant="outlined"
            />
          </div>
        </div> */}
        {/* <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', margin: '2px 0px' }}>
          <span className="filter-sub-label-x2" style={{ paddingLeft: '6px' }}>
            Date
          </span>
          <div style={{ display: 'flex', gap: '8px' }}>
            <DateField
              value={filterStateLocal.startDate}
              fullWidth
              variant="outlined"
              label="From"
              onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, startDate: e.toISOString() }))}
            />
            <DateField
              value={filterStateLocal.endDate}
              fullWidth
              variant="outlined"
              label="To"
              onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, endDate: e.toISOString() }))}
            />
          </div>
        </div> */}
        <div style={{ display: 'flex', justifyContent: 'end', gap: '8px' }}>
          <Button
            sx={{
              textTransform: 'capitalize',
              backgroundColor: '#ff4842',
              color: 'white',
              borderRadius: '30px',
              ':hover': { backgroundColor: '#d40700' },
            }}
            onClick={handleClose}
            size="small"
            variant="contained"
          >
            Close
          </Button>
          <Button
            sx={{
              textTransform: 'capitalize',
              borderRadius: '30px',
              backgroundColor: '#027c34',
              '&:hover': { backgroundColor: '#027d35' },
            }}
            onClick={handleFilterReset}
            size="small"
            variant="contained"
          >
            Reset
          </Button>
          <Button
            sx={{
              textTransform: 'capitalize',
              borderRadius: '30px',
              backgroundColor: '#027c34',
              '&:hover': { backgroundColor: '#027d35' },
            }}
            onClick={handleFilterApply}
            size="small"
            variant="contained"
          >
            Apply
          </Button>
        </div>
      </Menu>
    </div>
  );
};

export default FilterMenu;
